import React, { useState, useEffect } from 'react';

const PuestoSelect = ({ value, onChange, error, index }) => {
    const [puestos, setPuestos] = useState([]);

    const selectedPuesto = value?.puesto || '';
    const otroPuesto = value?.otroPuesto || '';
    const showOtros = value?.puesto === 'Otros';

    useEffect(() => {
        const fetchPuestos = async () => {
            try {
                const response = await fetch('https://apicv.conduto.com.ec/api/puestos');
                const result = await response.json();
                if (result.success) {
                    setPuestos(result.data.filter(p => p.nombre !== 'Otros'));
                }
            } catch (error) {
                console.error('Error fetching puestos:', error);
            }
        };

        fetchPuestos();
    }, []);

    const handleSelectPuesto = (e) => {
        const value = e.target.value;
        
        if (value === 'Otros') {
            onChange({ puesto: 'Otros', otroPuesto: '' });
        } else if (value === '') {
            onChange({ puesto: '', otroPuesto: '' });
        } else {
            onChange({ puesto: value, otroPuesto: null });
        }
    };

    const handleOtroPuestoChange = (e) => {
        const value = e.target.value;
        onChange({ puesto: 'Otros', otroPuesto: value });
    };

    return (
        <div>
            <div className="mb-3">
                <label className="form-label">Puesto / Cargo <span className="text-danger">*</span></label>
                <div className="input-group">
                    <select
                        className={`form-select ${error ? 'is-invalid' : ''}`}
                        value={selectedPuesto}
                        onChange={handleSelectPuesto}
                    >
                        <option value="">Seleccionar puesto</option>
                        {puestos.map((puesto) => (
                            <option key={puesto.id} value={puesto.nombre}>
                                {puesto.nombre}
                            </option>
                        ))}
                        <option value="Otros">Otros</option>
                    </select>
                </div>
                {error && <div className="invalid-feedback d-block">{error}</div>}
            </div>

            {showOtros && (
                <div className="mb-3">
                    <label className="form-label">Especifique el puesto <span className="text-danger">*</span></label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Ingrese el nombre del puesto"
                        value={otroPuesto}
                        onChange={handleOtroPuestoChange}
                    />
                </div>
            )}
        </div>
    );
};

export default PuestoSelect;